interface SeoHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
  schemaType?: string;
}

export default function SeoHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schema, schemaType }: SeoHeadProps) {
  const fullCanonical = `https://mingcidianzi162.cn${canonicalUrl}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:site_name" content="91浏览器" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      <meta name="geo.region" content="CN-11" />
      <meta name="geo.placename" content="北京" />
      <meta name="geo.position" content="39.9042;116.4074" />

      {schema && schemaType === 'Organization' && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
      {schema && schemaType === 'WebSite' && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
      {schema && schemaType === 'WebPage' && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
      {schema && schemaType === 'Article' && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
      {schema && schemaType === 'FAQPage' && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </>
  );
}